import { render, staticRenderFns } from "./u-table-color-bg.vue?vue&type=template&id=11608537&scoped=true&"
import script from "./u-table-color-bg.vue?vue&type=script&lang=js&"
export * from "./u-table-color-bg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11608537",
  null
  
)

export default component.exports